import { AnimatePresence } from 'framer-motion'
import { useCartContext } from '../context/CartContext'
import { useProfileContext } from '../context/ProfileContext'
import { CartOverlay } from './pages/cart/CartOverlay'
import { ProfileOverlay } from './pages/ProfileOverlay'

/**
 * Overlays — single mount point for the storefront drawer + slide-overs
 * (cart, profile). Lives INSIDE both CartProvider and ProfileProvider in
 * the AppRouter tree, so each overlay can read both contexts
 * (CartOverlay needs profile.open to launch "Add address"; ProfileOverlay
 * gets its onSaved bounce-back from ProfileProvider via context).
 *
 * Before this host the providers each mounted their own overlay inline,
 * but that meant CartOverlay was a sibling-of-children of CartProvider
 * and therefore ABOVE ProfileProvider in the tree — useProfileContext()
 * blew up when an authed customer opened the cart (blank-screen bug
 * 2026-06-05).
 */
export function Overlays(): JSX.Element {
  const cart = useCartContext()
  const profile = useProfileContext()
  return (
    <>
      <AnimatePresence>
        {cart.isOpen ? <CartOverlay onClose={cart.close} /> : null}
      </AnimatePresence>
      <AnimatePresence>
        {profile.isOpen ? (
          <ProfileOverlay onClose={profile.close} onSaved={profile.handleSaved} />
        ) : null}
      </AnimatePresence>
    </>
  )
}
